export default function Title({baslik,addClass}) {
  return (
    <div className={`${addClass}`}>{baslik}</div>
  )
}